

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETKRAKPIDBYID= createAsyncThunk(
  "getKraKpiById/getKraKpiById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getKraKpiByIdSlice = createSlice({
  name: "getKraKpiByIdSlice",
  initialState: {
    getKraKpiById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetKraKpiById: (state) => {
        state.getKraKpiById.loading = false
        state.getKraKpiById.error = false
        state.getKraKpiById.data = []
        state.getKraKpiById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETKRAKPIDBYID.fulfilled, (state, action) => {
      state.getKraKpiById = {
        ...state.getKraKpiById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETKRAKPIDBYID.pending, (state, action) => {
      state.getKraKpiById = {
        ...state.getKraKpiById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETKRAKPIDBYID.rejected, (state, action) => {
      state.getKraKpiById = {
        ...state.getKraKpiById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getKraKpiByIdAction = {
    GETKRAKPIDBYID,
};

export { getKraKpiByIdAction };
export default getKraKpiByIdSlice.reducer;
export const {setInitialStateOfgetKraKpiById} = getKraKpiByIdSlice.actions
